import store from "@/store";
import { getActivePinia } from "pinia";
import { usePrivilegesStore } from "@/stores/privileges";
import { useOrganizationStore } from "@/stores/organizationStore";
import { useSessionSelfStore } from "@/stores/sessionSelf";

/**
 * Pull privileges + MySQL session self when Vuex session is available (after
 * login, refresh, or entering/exiting a patient chart).
 *
 * GetSelfProfile is MFA-enforced on keyon — only fetch sessionSelf after 2FA
 * (or on resume when is2faVerified is already persisted). Privileges are not.
 */
export function syncPrivilegesAfterSessionChange() {
  const pinia = getActivePinia();
  if (!pinia || !store.getters["login/isLoggedIn"]) {
    return;
  }
  const phr = store.getters["login/getAllData"];
  if (!phr) {
    return;
  }
  usePrivilegesStore(pinia).fetchForCurrentSession(phr);
  if (store.state.login && store.state.login.is2faVerified) {
    useSessionSelfStore(pinia).fetchForCurrentSession();
  }
}

export function clearPrivilegesStore() {
  const pinia = getActivePinia();
  if (!pinia) {
    return;
  }
  usePrivilegesStore(pinia).clear();
  useSessionSelfStore(pinia).clear();
}

/** Clear cached accounts.organization on logout. */
export function clearOrganizationStore() {
  const pinia = getActivePinia();
  if (!pinia) {
    return;
  }
  useOrganizationStore(pinia).clear();
}
